import { Component, OnDestroy, OnInit } from '@angular/core';

import { CurrencyPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { DepositInfo } from '../../../../model/depositInfo.model';
import { BehaviorDataService } from '../../../../service/behaviorData.service';
import { DepositService } from '../../../../service/deposit.service';
import { OptionListService } from '../../../../service/optionList.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'lcg-txn-details',
    templateUrl: './txn-details.component.html',
    imports: [TranslateModule, CurrencyPipe],
})
export class LCGTxnDetailsComponent implements OnInit, OnDestroy {
    subscriptions$: Subscription[] = [];
    depositInfo: DepositInfo;
    stakeAmountToBePopulated: any;
    currency: any;
    estimatedReturn: any;
    amountInAccCurrency: any;
    currencyCode: any;
    constructor(
        private depositService: DepositService,
        private optionListService: OptionListService,
        private behaviorData: BehaviorDataService,
    ) {
        this.depositInfo = this.depositService.depositInfo;
        this.currencyCode = this.optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode;
    }

    ngOnInit(): void {
        this.subscriptions$.push(
            this.behaviorData.amountInAccCurrency.subscribe((data) => {
                this.amountInAccCurrency = data;
            }),
        );
        this.subscriptions$.push(
            this.behaviorData.estimatedReturn.subscribe((data) => {
                this.estimatedReturn = data;
            }),
        );
        this.subscriptions$.push(
            this.behaviorData?.getStakeCurrency.subscribe((data) => {
                this.currency = data;
            }),
        );
        this.subscriptions$.push(
            this.behaviorData?.getStakeAmount.subscribe((data) => {
                this.stakeAmountToBePopulated = data;
            }),
        );
    }
    ngOnDestroy(): void {
        this.subscriptions$.map((subscription) => subscription.unsubscribe());
    }
}
